(() => {
  const success = document.querySelector('#ContactForm [data-contact-success]');
  if (!success) return;
  // A Shopify success URL must not replay the confirmation on refresh.
  if (performance.getEntriesByType('navigation')[0]?.type === 'reload') success.remove();
  const url = new URL(window.location.href);
  if (url.searchParams.get('contact_posted') === 'true') {
    url.searchParams.delete('contact_posted');
    window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
  }
})();
